import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MenuStore } from '../../../menus/service/menu.store';
import { OnyxEvent } from '../../models/event';
import { EventStore } from '../../service/event.store';
import { PaymentStore } from '../../service/payment.store';
import { Payment } from '../../models/payment';

@Component({
  selector: 'pioneer-commission',
  templateUrl: './commission.component.html'
})
export class CommissionComponent implements OnInit {

  commissionForm: FormGroup;
  onyxEvent: OnyxEvent;
  latestPayment: Payment;

  ui = {
    showAddPayment: false,
    showPaymentRecord: false
  };

  constructor(
    private formBuilder: FormBuilder,
    private menuStore: MenuStore,
    private eventStore: EventStore,
    private paymentStore: PaymentStore
  ) {}

  ngOnInit() {

    this.eventStore.selectedEvent.subscribe((event: OnyxEvent) => {
      this.onyxEvent = new OnyxEvent(event);
    });

    this.paymentStore.getLatestPayment().subscribe((latestPayment: Payment) => {
      this.latestPayment = latestPayment;
      const status = this.latestPayment.status;
      if (status) {
        this.ui.showPaymentRecord = true;
        this.ui.showAddPayment = false;
      } else {
        this.ui.showPaymentRecord = false;
        this.ui.showAddPayment = true;
      }
    });

    this.commissionForm = this.formBuilder.group({});
    this.menuStore.setPageTitle('EVENT.EVENT_INFO_TITLE');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/payment/commission/commission.component.ts